import React from 'react';
import css from './styles.module.scss';
import { Button } from '@material-ui/core';

interface StepControlsProps {
    onPrevClick?: () => void;
    onNextClick?: () => void;
    errors?: any;
    isSubmitting?: any;
    nextButton?: JSX.Element;
    className?: string;
}

export const StepControls: React.FC<StepControlsProps> = ({
  className,
  onPrevClick,
  onNextClick,
  errors,
  isSubmitting,
  nextButton,
}) => {
    return (
        <div className={`${css.module} ${className}`}>
            {onPrevClick && (
                // <IconButton onClick={onPrevClick} className={css.paginationItem}>
                //     <KeyboardArrowLeftIcon className={css.paginationItemIcon} />
                // </IconButton>
                <Button className={css.prevButton} onClick={onPrevClick}>
                    Back
                </Button>
            )}
            {/* <IconButton className={css.paginationItem} type="submit">
                <KeyboardArrowRightIcon className={css.paginationItemIcon} />
            </IconButton> */}

            {nextButton || (
                <Button
                    className={css.nextButton}
                    type="submit"
                    disabled={isSubmitting}
                    {...(onNextClick ? { onClick: onNextClick } : {})}
                >
                    {isSubmitting ? 'Loading...' : 'Next'}
                </Button>
            )}
        </div>
    );
};
